<script>
    export let value = null
    export let maxLength = 500
    export let disabled = false
    export let style = ''
    export let valid = true
    export let validation = (_) => true
    export let required = false
    export let label = null
    export let placeholder = null
    // export let valid = false;
    export let name = null
    import { getContext, onDestroy } from 'svelte'
    const formData = getContext('formData')
    import { Typography } from './'
    $: if (value || value === '')
        value = value.length > maxLength ? value.slice(0, maxLength) : value
    $: valid = validation ? validation(value) : true
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid,
                            validation: false,
                            required,
                            value,
                            label,
                            labelOption: null,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
</script>

<div {style}>
    {#if label}
        <label for={name}
            ><Typography type="body" color="grey-800">{label}</Typography
            ></label
        >
    {/if}
    <div class="st1">
        <textarea
            {placeholder}
            {disabled}
            id={name}
            class="textarea"
            width="100"
            bind:value
        ></textarea>
        <!-- <Typography
      style="margin: 0; align-self: flex-end"
      type="subtitle"
      color="grey-300">{value ? value.length : "0"}/{maxLength}</Typography
    > -->
        <Typography
            style="margin: 0; align-self: flex-end"
            type="subtitle"
            color="grey-300"
            >{maxLength - (value ? value.length : 0)}</Typography
        >
    </div>
</div>

<style>
    .st1 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        position: relative;
        border: 1px solid #cccccc;
        border-radius: 8px;
        padding: 19px 16px;
        width: 100%;
        min-width: 250px;
        overflow: hidden;
        user-select: none;
    }
    .st1 textarea::-webkit-scrollbar {
        display: none;
    }
    .st1 textarea::placeholder {
        color: var(--color-grey-400);
    }
    .st1 textarea {
        display: flex;
        width: 100%;
        resize: none;
        border-style: none;
        background: transparent;
        outline: none;
        overflow-y: scroll;
        box-sizing: border-box;
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0.2px;
    }
</style>
